const attackTypeLabel = (attackType) => {
    if (attackType === null || attackType === undefined) return null;
    switch (attackType) {
        case 1:
            return 'Melee';
        case 2:
            return 'Ranged';
        case 3:
            return 'Spell';
        default:
            return String(attackType);
    }
};

const removeHtmlTags = (html = '') => {
    if (typeof document !== 'undefined') {
        const temp = document.createElement('div');
        temp.innerHTML = html;
        return temp.textContent || temp.innerText || '';
    }

    return html
        .replace(/<br\s*\/?>/gi, '\n')
        .replace(/<\/p>/gi, '\n')
        .replace(/<[^>]+>/g, '')
        .replace(/&nbsp;/gi, ' ')
        .replace(/&amp;/gi, '&')
        .replace(/&lt;/gi, '<')
        .replace(/&gt;/gi, '>')
        .replace(/&quot;/gi, '"')
        .replace(/&#39;/gi, "'")
        .replace(/\s+/g, ' ')
        .trim();
};

const formatDamage = (damage) => {
    if (!damage) return null;
    if (damage.diceString) return damage.diceString;
    const parts = [];
    if (damage.diceCount && damage.diceValue) {
        parts.push(`${damage.diceCount}d${damage.diceValue}`);
    }
    if (damage.fixedValue || damage.fixedValue === 0) {
        parts.push(`${damage.fixedValue}`);
    }
    return parts.join(' + ');
};

const formatRange = (range, longRange) => {
    if (range == null && longRange == null) return null;
    if (range != null && longRange != null && range === longRange) {
        return `${range}`;
    }
    if (range != null && longRange != null) {
        return `${range}/${longRange}`;
    }
    return range != null ? `${range}` : `${longRange}`;
};

const buildEntrySummary = (item) => {
    const parts = [];
    if (item.type) parts.push(item.type);

    const attackLabel = attackTypeLabel(item.attackType);
    if (attackLabel) parts.push(attackLabel);

    const damageText = formatDamage(item.damage);
    if (damageText) {
        parts.push(`${damageText}${item.damageType ? ` ${item.damageType}` : ''}`.trim());
    } else if (item.damageType) {
        parts.push(item.damageType);
    }

    const rangeText = formatRange(item.range, item.longRange);
    if (rangeText) parts.push(`Range ${rangeText}`);

    if (Array.isArray(item.properties) && item.properties.length > 0) {
        const propNames = item.properties.map((prop) => prop.name).filter(Boolean);
        if (propNames.length) parts.push(`Properties: ${propNames.join(', ')}`);
    }

    if (Array.isArray(item.grantedModifiers) && item.grantedModifiers.length > 0) {
        const mods = item.grantedModifiers
            .map((mod) => {
                const value = mod.fixedValue != null ? `+${mod.fixedValue}` : mod.dice || '';
                return [value, mod.type, mod.subType].filter(Boolean).join(' ');
            })
            .filter(Boolean);
        if (mods.length) parts.push(`Modifiers: ${mods.join(', ')}`);
    }

    return `{@b ${parts.join(' • ')}}`;
};

export const mapDndBItemsToLairActions = (items = []) => {
    if (!Array.isArray(items)) return [];

    return items.map((item) => {
        const name = item?.name || 'Unnamed item';
        const description = removeHtmlTags(item?.description || '');
        const summary = buildEntrySummary(item);

        const entryParts = [summary, description].filter(Boolean);
        const entry = entryParts.join('. ');

        return {
            type: 'item',
            name,
            entry,
            rechargeCount: 0,
        };
    });
};
